<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Từ ngày</label>
              <date-picker v-model="filterData.from_date" valueType="format"></date-picker>
            </div>
            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Đến ngày</label>
              <date-picker v-model="filterData.to_date" valueType="format"></date-picker>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái cuộc gọi</label>
              <multiselect v-model="filterData.call_status" :options="call_status_list" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center ">
              <b-button variant="warning" @click="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Báo cáo tổng đài">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(id)="data">
                {{genSeqId(data)}}
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import callCenterAPI from '../../api/callCenter'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import * as Constants from '../../common/constant'

export default {
  name: 'CallReport',
  components: {
    'va-box': VABox,
    DatePicker,
    Multiselect
  },
  data () {
    return {
      filterData: {
        from_date: moment().subtract(1, 'days').format('yyyy-MM-DD'),
        to_date: moment().format('yyyy-MM-DD'),
        call_status: null
      },
      call_status_list: Constants.CALL_STATUS_LIST,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT'
        },
        {
          key: 'agent_name',
          label: 'Agent'
        },
        {
          key: 'number_call_out',
          label: 'Số lượng cuộc gọi đi'
        },
        {
          key: 'duration_call_out',
          label: 'Thời lượng cuộc gọi đi(giây)'
        },
        {
          key: 'number_call_in',
          label: 'Số lượng cuộc gọi đến'
        },
        {
          key: 'duration_call_in',
          label: 'Thời lượng cuộc gọi đến(giây)'
        },
        {
          key: 'total_duration',
          label: 'Tổng thời lượng đàm thoại(giây)'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ]
    }
  },
  mounted () {
    this.filter()
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    filter () {
      if (this.loading) {
        return
      }

      this.loading = true
      let filter = {...this.filterData}
      filter.call_status = this.filterData.call_status ? this.filterData.call_status.value : null
      callCenterAPI.get_call_report(filter, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/call_center/CallReport.vue